import { jsonRegex } from 'ts-loader/dist/types/constants';
import { DH_UNABLE_TO_CHECK_GENERATOR } from 'constants';
export default class FeedbackPage {
    private $page = $('.p-fankui .main-body');
    private arrUploadImg: string[] = [];

    public init() {
        const that = this;
        this.verifyChartRemaining();
        this.uploadImg();
        this.verifyContact();
        this.verifyCode();
        this.submit();
        console.log('fankui')
    }

    public verifyChartRemaining() {
        const $textArea = this.$page.find('textarea');
        const $remainingTips = this.$page.find('.content-tips-remaining');
        const that = this;

        $textArea.on('input', function (e) {
            const value = String($(this).val()) || '';
            const chartLength = value.length;
            that.$page.find('.content').removeClass('is-error').addClass('is-ok');
            $('.content-tips').addClass('hide');
            $remainingTips.text(`${chartLength}/${1000 - chartLength}`).removeClass('hide');
            if (chartLength >= 998) {
                e.preventDefault();
                $(this).val(value.substr(0, 1000));
            }
        })

        $textArea.on('blur', function (e) {
            const value = String($(this).val()) || '';
            const chartLength = value.length;
            if (chartLength < 1) {
                that.$page.find('.content').addClass('is-error').removeClass('is-ok');
                $remainingTips.addClass('hide');
                $('.content-tips').removeClass('hide');
            }
        })
    }

    public uploadImg() {
        const $btnUpload = this.$page.find('#write-file');
        const that = this;

        $btnUpload.on('change', function (e) {
            const $this = $(this);

            if ($this.val() !== '') {
                console.log(e);
                const uploadFile = (e as any).target.files[0];
                const errorInfo = $('.upload-file .img-tips');
                if (!(/\.(jpg|jpeg)$/i).test(uploadFile.name)) {
                    errorInfo.text('仅支持格式为jpg的图片').removeClass('hide');
                    $this.val('');
                } else if (uploadFile.size > (10*1024*1024)) { // 10MB
                    errorInfo.text('上传的图片大小不能超过1M。').removeClass('hide');
                    $this.val('');
                } else {
                    errorInfo.addClass('hide');
                    that._ajaxUploadImg();
                }
                setTimeout(function () {
                    errorInfo.addClass('hide');
                }, 3000)
            }
        })

        that.$page.find('.upload-file').on('click', '.thumb-wrap .btn-remove', function (e) {
            const $this = $(this);
            const $uploadForm: any = that.$page.find('.upload-file-form');
            $.ajax({
                url: '/e/api/removeImage.php',
                type: 'POST',
                data: {
                    'id': 1
                },
                processData: false,
                contentType: false
            }).done(function (res) {
                if (res.code === 200) {
                    // remove image
                    const imgIndex = that.arrUploadImg.indexOf($this.data('url'));
                    if (imgIndex > -1) {
                        that.arrUploadImg.splice(imgIndex, 1);
                    }

                    $this.parents('.thumb-wrap').remove();
                    if ($uploadForm.siblings('.thumb-wrap').length < 3) { $uploadForm.show(); }
                }
            }).fail(function (res) {
                console.log((res as any).message)
            });
            // console.log(this);
        })
    }

    public verifyContact() {
        const $contact = this.$page.find('.contact-input');

        $contact.on('blur', function () {
            const value = String($(this).val()) || '';
            const $errorTips = $('.contact-tips');
            console.log(value);
            if (value === '') {
                $(this).addClass('is-error').removeClass('is-ok');
                $errorTips.text('请输入手机号或者电子邮箱').removeClass('hide');
            } else if (!value.match(/^(13|14|15|16|17|18|19)\d{9}$/)
                && !value.match(/^\w+([\-\+.]\w+)*\@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) {
                $(this).addClass('is-error').removeClass('is-ok');
                $errorTips.text('请输入正确的手机号或者电子邮箱').removeClass('hide');
            } else {
                $(this).removeClass('is-error').addClass('is-ok');
                $errorTips.addClass('hide');
            }
        })
    }

    public verifyCode() {
        const $verifyInput = this.$page.find('.verify-code-input');

        $verifyInput.on('blur', function () {
            const value = String($(this).val()) || '';
            const $errorTips = $('.verify-tips');
            if (value === '') {
                $(this).addClass('is-error').removeClass('is-ok')
                $errorTips.text('请输入验证码').removeClass('hide');
            } else {
                $(this).removeClass('is-error').addClass('is-ok');
                $errorTips.addClass('hide');
            }
        })
    }

    public submit() {
        const $btnSubmit = this.$page.find('.btn-submit');
        const that = this;

        $btnSubmit.on('click', function () {
            if (!that.$page.find('.content').hasClass('is-ok')
                || !that.$page.find('.contact-input').hasClass('is-ok')
                || !that.$page.find('.verify-code-input').hasClass('is-ok')) {
                return
            } else {
                that._ajaxSubmit();
            }
        })
    }

    private _ajaxUploadImg() {
        const $uploadForm: any = this.$page.find('.upload-file-form');
        const fd = new FormData($uploadForm[0]);
        const that = this;
        // fd.append("type", 'comment');
        $.ajax({
            url: '/e/api/uploadImage.php',
            type: 'POST',
            data: fd,
            processData: false,
            contentType: false
        }).done(function (res) {
            if (res.code === 200) {
                const html = '<div class="thumb-wrap pull-left">' +
                    '<img class="thumb"  src="' + res.result.url + '" data-id="' + res.result.id + '">' +
                    '<div class="icon-s btn-remove" data-url="' + res.result.url + '" data-id="' + res.result.id + '">' +
                    '</div></div>';
                that.arrUploadImg.push(res.result.url);
                $uploadForm.before(html);
                if ($uploadForm.siblings('.thumb-wrap').length >= 3) { $uploadForm.hide(); }
            }
        }).fail(function (res) {
            console.log((res as any).message)
        });
    }

    private _ajaxSubmit() {

        const key = this.$page.find('input[name="key"]').val();
        const mycall = this.$page.find('input[name="mycall"]').val();
        const saytext = this.$page.find('textarea[name="saytext"]').val();
        const data = {
            saytext: saytext,
            mycall: mycall,
            images: this.arrUploadImg,
            key: key
        };
        $.ajax({
            url: '/e/api/feedback.php',
            type: 'POST',
            data: data,
            dataType: 'json'
        }).done(function (res) {
            if (res.code === 200) {
                (window as any).location.href = '/html/feedback_success.html';
            } else {
                switch (res.code) {
                    case 1001:
                        console.log('验证码错误');
                        $('.verify-tips').text(res.result.message).removeClass('hide');
                        break;
                    case 500:
                        console.log('服务器错误');
                        $('#server-error-modal').modal('show');
                        break;
                    default:
                        console.log('其它错误');

                }
            }
        }).fail(function (res) {
            $('#server-error-modal').modal('show');
            console.log((res as any).message)
        });
    }
}
